import { defineComponent } from "vue";
export default defineComponent({
  name: "FormInput",
  props: {
    modelValue: { type: String },
    identifier: { type: String },
    type: { type: String },
    class: { type: String },
  },
  emits: ["update:modelValue"],
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(val: any) {
        this.$emit("update:modelValue", val);
      },
    },
  },
});
